import type { BillingCycle, MembershipPlanType } from "@features/membership/model/types";
import dayjs from "dayjs";

export const SILVER_TOUR_HIDDEN_DATE_STORAGE_KEY = "82office-silver-tour-hidden-date";

export function isSilverTourHiddenToday() {
  const hiddenDate = localStorage.getItem(SILVER_TOUR_HIDDEN_DATE_STORAGE_KEY);

  return hiddenDate !== null && dayjs(hiddenDate).isSame(dayjs(), "day");
}

export function hideSilverTourForToday() {
  localStorage.setItem(SILVER_TOUR_HIDDEN_DATE_STORAGE_KEY, dayjs().format("YYYY-MM-DD"));
}

export function formatPlanDisplay(
  type: MembershipPlanType,
  billingCycle: BillingCycle,
  t: (key: string) => string,
): string {
  const typeLabel = t(`membershipPlan_${type}`);
  const billingLabel = t(`billingCycle_${billingCycle}`);
  return `${typeLabel} (${billingLabel})`;
}
